import getHexConsumerIdForUser from '../actions/getHexConsumerIdForUser';
import getPersonaPhotoUrl from '../utils/getPersonaPhotoUrl';
import { getPersonaPhotoUrlFromhexCID } from '../utils/getPersonaPhotoUrl';
import { PersonaIdentifiers } from 'owa-persona/lib/personaConfig';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';

export default function getAndPrefetchPersonaImageUri(
    personaId: PersonaIdentifiers,
    callback: (uri?: string, headers?: { [key in string]: string }, error?: string) => void,
    imageStyle?: string
): void {
    const hexCid: string = getHexConsumerIdForUser(personaId.Smtp);
    callback(
        hexCid
            ? getPersonaPhotoUrlFromhexCID(hexCid, PersonaSize.regular)
            : getPersonaPhotoUrl(personaId.Smtp, undefined, imageStyle === 'largeRounded')
    );
}
